import { Component, ElementRef, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { IonContent, ModalController, Platform } from '@ionic/angular';
import { NgModel } from '@angular/forms';
import { RestaurantStore } from 'src/app/core/stores/restaurant.store';
import { CartStore } from 'src/app/core/stores/cart.store';
import { PaymentStore } from '../../../../core/stores/payment.store';
import { from, Observable, of, Subject } from 'rxjs';
import { auditTime, concatMap, filter, mapTo, takeUntil, tap } from 'rxjs/operators';
import { RouteService } from '../../../../core/services/route.service';
import {
  CatalogData,
  Country,
  Merchant,
  ProductVariation,
  Restaurant,
  RestaurantAvailableStatus,
  RestaurantCategory,
  RestaurantProduct,
  Taxes,
  WorkDay
} from 'src/app/core/models/restaurant.model';
import { MenuItemForPayment, ProductCollapseState } from 'src/app/core/models/cart-item.model';
import { environment } from 'src/environments/environment';
import { Loyalty, Order, SavedOrder } from '../../../../core/models/payment-item.model';
import { OrderApiService } from '../../../../core/services/order.api.service';
import { PaymentService } from '../../../../core/services/payment.service';
import { ItemValidateService } from '../../../../core/services/item-validate.service';
import { ProductModalComponent } from '../../../../shared/components/product-modal/product-modal.component';
import { FormatDataService } from '../../../../core/services/format-data.service';
import { FormatStyleService } from '../../../../core/services/format-style.service';
import { FulfillmentType, SubscriptionPhase } from '../../../../core/models/order.model';
import { UtilService } from 'src/app/core/services/util.service';

import * as moment from 'moment';
import { BASE_URL_PATH, STORAGE_CUSTOMER_DATA } from 'src/app/core/constants';
import { MerchantStore } from 'src/app/core/stores/merchant.store';
import { Platforms } from '../../../../core/enums/util.enum';
import { URL } from '../../../../core/enums/url.enum';
import { ItemService } from '../../../../core/services/item.service';
import {UrlParam} from '../../../../core/enums/group-param.enum';
import {SharedOrdersModalComponent} from '../shared-orders-modal/shared-orders-modal.component';
import {MatDialog} from '@angular/material/dialog';
import {SharedOrderService} from '../../../../core/services/shared-order.service';
import { OrderWithFlavorStore } from 'src/app/core/stores/orderwithflavor.store';
import { CustomerStore } from 'src/app/core/stores/customer.store';
import { FavoriteProductService } from 'src/app/core/services/favorite-product.service';
import { organizeCategories } from '../../../../core/dto/catalog.dto';
import {isItemDailyAvailable, isShowDailyAvailabilityItem} from '../../../../core/dto/item.dto';
import { StorageService } from 'src/app/core/services/storage.service';
import {RestaurantService} from '../../../../core/services/restaurant.service';

@Component({
  selector: 'app-restaurants',
  templateUrl: './restaurants.component.html',
  styleUrls: ['./restaurants.component.scss']
})
export class RestaurantsComponent implements OnInit, OnDestroy {

  @ViewChild(IonContent, {static: true}) content: IonContent;
  @ViewChild(NgModel, {static: true}) customAmountInput: NgModel;
  @ViewChild('categoryTabContainer', {static: false, read: ElementRef}) categoryTabContainer: ElementRef;
  @ViewChild('categoryWrapper', {static: false, read: ElementRef}) categoryWrapper: ElementRef;
  @ViewChild('rightButton', {static: false, read: ElementRef}) rightButton: ElementRef;
  @ViewChildren('categoryTab', {read: ElementRef}) categoryTabList: QueryList<ElementRef>;
  @ViewChildren('category', {read: ElementRef}) categories: QueryList<ElementRef>;

  public get categoryTabArray() {
    return this.categoryTabList.toArray();
  }
  public get categoryTabListLeft() {
    return this.categoryTabList.map((category) => category.nativeElement.offsetLeft);
  }

  private destroyed$ = new Subject<void>();
  public isQueueWithKyoo: boolean;

  public locationId: string;
  public addItemQueue = [];
  public restaurant: Restaurant = new Restaurant();
  public restaurants: Restaurant[];
  public filteredWorkDays: WorkDay[];
  public taxes: Taxes[];

  public isRestaurant = true;
  public isTaxes = false;

  public selectedProduct: RestaurantProduct;
  public filteredProductList: RestaurantProduct[][] = [];
  public isShowProductModal = false;
  public isShowRestaurantClosedModal = false;
  public isModalWasClosed: boolean;
  public isRestaurantClosed = false;
  public isClickOnLastTab = false;
  public isScrollPositionTop = true;
  public isShowAgeGateModal = false;
  public isAlcoholHidden = false;
  public modal = null;

  public fromPayment = false;
  public ordersIsEmpty: boolean;

  public isSpiceKitchen: boolean;
  private merchantId: string;
  public isCatalogEmpty: boolean;
  public merchant: Merchant;
  public orderBotUserId: string;
  public favoriteItems: string[] = [];
  public restaurantCategories: RestaurantCategory[] = [];
  public activeCategoryId: string;
  public isAutoScrolling = false;
  protected readonly isShowDailyAvailabilityItem = isShowDailyAvailabilityItem;
  protected readonly isItemDailyAvailable = isItemDailyAvailable;

  public get isMobile(): boolean {
    return this.platform.is('mobile') || this.platform.width() < 600;
  }

  public get showCheckout(): boolean {
   return this.isMobile && this.cartStore.items.length > 0;
  }

  public get placeCategoryTabsInHeader(): boolean {
    return this.isMobile && !this.isScrollPositionTop;
  }

  public get showCategoryTabsLeftArrow(): boolean {
    return this.categoryWrapper && this.categoryWrapper.nativeElement &&
      this.categoryWrapper.nativeElement.scrollLeft > 10;
  }

  public get showCategoryTabsRightArrow(): boolean {
    return this.categoryWrapper && this.categoryWrapper.nativeElement &&
      this.categoryWrapper.nativeElement.scrollWidth - 10 >
      this.categoryWrapper.nativeElement.clientWidth + this.categoryWrapper.nativeElement.scrollLeft;
  }

  public get isRestaurantHaveEnabledWorkDays(): boolean {
    return !!this.restaurant.hoursOfOperation.find( (day) => day.enable === true);
  }

  public get isCategoriesCollapsable(): boolean {
    return this.restaurant ? this.restaurant.categoriesCollapsable : false;
  }

  public get isStoneCreek(): boolean {
    return this.utilService.isStoneCreek();
  }

  public get checkPlatform(): boolean {
    return this.platform.is(Platforms.CORDOVA);
  }

  constructor(
    public restaurantStore: RestaurantStore,
    public cartStore: CartStore,
    private route: ActivatedRoute,
    private router: Router,
    private titleService: Title,
    private platform: Platform,
    private paymentStore: PaymentStore,
    private modalController: ModalController,
    private routeService: RouteService,
    private orderApiService: OrderApiService,
    private paymentService: PaymentService,
    private itemValidateService: ItemValidateService,
    private formatDataService: FormatDataService,
    private formatStyleService: FormatStyleService,
    public utilService: UtilService,
    private merchantStore: MerchantStore,
    private itemService: ItemService,
    private dialog: MatDialog,
    private sharedOrderService: SharedOrderService,
    private orderWithFlavorStore: OrderWithFlavorStore,
    private customerStore: CustomerStore,
    private favoriteProductService: FavoriteProductService,
    private storageService: StorageService,
    private restaurantService: RestaurantService,
  ) {
  }

  async ngOnInit() {
    this.paymentService.getCustomerOpenedTab();
    this.isQueueWithKyoo = environment.isLine;
    this.route.params.subscribe(params => {
      if (params.locationId) {
        this.locationId = params.locationId;
        this.merchantId = params.merchantId;
        this.getRestaurant();
        this.initRouteConfig();
        this.initComponent();
      } else if (params.transactionId) {
        this.restaurantStore.isKioskSmsOrder = true;
        this.paymentStore.transactionId = params.transactionId;
      }
      if (params && params.tableNumber) {
        this.restaurantStore.checkRouteContainsTableNumber(params.tableNumber);
      }
    });
    
    this.restaurantStore.checkRoutQueryParams();
    
    this.getMerchant();
    this.restaurantStore.filteredWorkHours$
      .pipe(filter(Boolean))
      .subscribe((result: any) => {
        if (result[this.locationId]) {
          this.filteredWorkDays = this.formatDataService.formatIfStoreContinueWorking(result[this.locationId]);
        }
      });
    this.getIsCatalogEmpty();
    this.sharedOrderService.setStorageCartItems();
    this.getSavedItems();
    this.setupCustomerFavoriteItems();
    this.merchantStore.loyaltyProgram$.subscribe((loyaltyProgram: any) => {
      if(loyaltyProgram){
        for(const reward of loyaltyProgram) {
          this.restaurantStore.getProductsByReward(reward.id, this.locationId, this.merchantId);
        }
      }
    });
    this.setupCustomerFavoriteItems();
    setTimeout(() => {
      this.restaurantService.checkQROrderOnlyOrder(this.restaurant);
    }, 1000);
  }

  private initComponent(locationId = null): void {
    if (locationId) {
      this.locationId = locationId;
      this.initRouteConfig();
      this.getRestaurant();
    }
    this.isSpiceKitchen = this.router.url.includes('DNXQ7KWQQKV4V');
    this.fromPayment = this.route.snapshot.queryParams.fromPayment || false;
    this.isAlcoholHidden = this.route.snapshot.queryParams.ignore === '21' || false;
    this.restaurantStore.bootstrapRestaurants(this.merchantId);
    if (this.restaurantStore.isKioskSmsOrder) {
    } else {
      this.merchantStore.getLoyaltyProgram(this.routeService.getMerchantId());
      this.merchantStore.getMerchantData(this.routeService.getMerchantId());
    }
    this.checkOrdersIsEmptyField();
    this.content.ionScroll.pipe(auditTime(200)).subscribe((event) => this.trackScroll(event));
  }

  private initRouteConfig() {
   this.restaurantStore.checkRouteContainsTimeRangeOptions();
   this.restaurantStore.checkRouteContainsFullfillmentOptions();
   this.sharedOrderService.getSharedOrderId();
   this.sharedOrderService.getSharedOwnerId();
  }

  ngOnDestroy() {
    this.destroyed$.next();
  }

  public get isShowClosedModal(): boolean {
    if (this.isModalWasClosed) {
      return false;
    }
    return this.isShowRestaurantClosedModal && !this.isShowAgeGateModal;
  }

  public async trackScroll(event): Promise<void> {
    if (this.isAutoScrolling) return;

    const element = await this.content.getScrollElement();
    const offsetForHeader = this.isScrollPositionTop ? 100 : 0;
    const isHideScroll = element.offsetHeight === element.scrollHeight;
    this.isScrollPositionTop = event.detail.scrollTop <= offsetForHeader && !isHideScroll;

    const { scrollTop } = event.detail;
    const scrollPosition = scrollTop + element.offsetHeight;
    const scrollThreshold = element.scrollHeight - 10;

    if (scrollPosition >= scrollThreshold) {
      this.activeCategoryId = this.restaurantCategories[this.restaurantCategories.length - 1].id;
      return;
    }

    this.activeCategoryId = this.restaurantCategories[0].id;

    const visibleCategories = this.restaurantCategories.filter(category => !this.isHideCategory(category));

    for (let index = 0; index < visibleCategories.length; index++) {
      const category = visibleCategories[index];
      const categoryElement = document.getElementById(`category-${category.id}`);
      const nextCategoryElement = visibleCategories[index + 1]
        ? document.getElementById(`category-${visibleCategories[index + 1].id}`)
        : null;

      if (!categoryElement) continue;

      const categoryTop = categoryElement.offsetTop;
      const nextCategoryTop = nextCategoryElement ? nextCategoryElement.offsetTop : Infinity;

      if (scrollTop >= categoryTop && scrollTop < nextCategoryTop) {
        this.activeCategoryId = category.id;
        break;
      }
    }
  }

  public hideSoldout(product: RestaurantProduct): boolean {
    return this.restaurant.hideSoldOutItems ? this.itemService.isSoldOut(product, this.restaurant) : false;
  }

  public toggleCategory(category: RestaurantCategory): void {
    if (this.isCategoriesCollapsable) {
      category.hideItems = !category.hideItems;
    }
  }

  public async scrollToCategory(category: RestaurantCategory, isLast: boolean): Promise<void> {
    this.isClickOnLastTab = isLast;
    this.isAutoScrolling = true;
    this.activeCategoryId = category.id;
    if (this.isCategoriesCollapsable) {
      category.isCollapse = true;
      category.hideItems = false;
    }
    const categoryElement = document.getElementById(`category-${category.id}`);
    if (!categoryElement) return;

    await this.content.scrollToPoint(0, categoryElement.offsetTop, 300);
    this.isAutoScrolling = false;
  }

  public scrollToPreviousCategoryTabs() {
    const nextScrollPosition = this.categoryWrapper.nativeElement.scrollLeft;
    const scrollToIndex = this.categoryTabListLeft.findIndex((categoryTabLeft, index) => {
      if (index !== 0) {
        const previousCategoryTabLeft = this.categoryTabListLeft[index - 1];
        return previousCategoryTabLeft <= nextScrollPosition && nextScrollPosition <= categoryTabLeft;
      }
    });
    this.categoryTabArray[scrollToIndex].nativeElement.scrollIntoView({inline: 'end', behavior: 'smooth'});
  }

  public scrollToNextCategoryTabs() {
    const nextScrollPosition = this.categoryWrapper.nativeElement.clientWidth + this.categoryWrapper.nativeElement.scrollLeft;
    const scrollToIndex = this.categoryTabListLeft.findIndex((categoryTabLeft, index) => {
      if (index !== this.categoryTabListLeft.length - 1) {
        const nextCategoryTabLeft = this.categoryTabListLeft[index + 1];
        return categoryTabLeft <= nextScrollPosition && nextScrollPosition <= nextCategoryTabLeft;
      } else {
        return true;
      }
    });
    this.categoryTabArray[scrollToIndex].nativeElement.scrollIntoView({inline: 'start', behavior: 'smooth'});
  }

  public changeLastTabFlag(): void {
    this.isClickOnLastTab = false;
  }
  public orderLoaded(event: SavedOrder): void {
    if (event) {
      this.merchantId = event.merchantId;
      this.locationId = event.locationId;
      this.initComponent();
      this.getRestaurant();
      this.initRouteConfig();
    }
  }

  public getMerchant(): void {
    // this.merchantStore.merchantData$.pipe(takeUntil(this.destroyed$)).subscribe(merchant => {
    //   this.merchant = merchant;
    //   if(merchant && merchant.useFlavorShiftsTime){
    //     this.restaurantStore.getRestaurants().pipe(takeUntil(this.destroyed$)).subscribe(restaurants =>{
    //       if(restaurants.length) {
    //         console.log("restaurants loadShifts")
    //         this.orderWithFlavorStore.loadShifts(merchant.vanityLink, restaurants);
            this.orderWithFlavorStore.restaurants$.pipe(takeUntil(this.destroyed$)).subscribe((r)=>{
              if(r.length){
                this.getFlavorRestaurant()
              }
            })
    //       }
    //     })
    //   }
    // })
  }

  private setupRestaurantDetails(restaurant: Restaurant): void {
    if (restaurant) {
      this.restaurant = restaurant;
      this.checkSharedOrder();
      this.cartStore.kyooFee = restaurant.kyooFee;
      this.checkCustomInstruction();
      this.cartStore.autoGratuityPercent = restaurant.autoGratuityPercent;
      this.cartStore.driverGratuityPercent = restaurant.defaultDeliveryAutoGratuityPercent;
      this.cartStore.enableRestaurantTips = restaurant.enableRestaurantTip;
      this.cartStore.tippingEnabled = restaurant.isTippingEnabled;
      this.cartStore.orderConfirmationText = restaurant.orderConfirmationText;
      this.titleService.setTitle(restaurant.name);
      this.restaurantStore.hideRestaurantOrdersAhead = restaurant.hideOrdersAhead;
      this.restaurantStore.disableTodayOrders = restaurant.disableTodayOrders;
      this.restaurantStore.timezone = restaurant.timezone;
      this.restaurantStore.loyaltyPointsName = restaurant.newLoyaltyPointsName;
      this.restaurantStore.restaurantCountryInfo = Country.getCountryByName(restaurant.country);
      this.restaurantStore.estimateDeliveryTime =
        this.itemValidateService.convertLeadTimeToMinutes(restaurant.estimatedPrepTimeDuration) +
        this.itemValidateService.convertLeadTimeToMinutes(restaurant.addlDeliveryPrepTimeDuration);

      this.formatStyleService.setGlobalBrandColor(restaurant.brandColor);
      this.formatStyleService.setGlobalBackgroundColor(restaurant.backgroundColor);
      this.formatStyleService.setGlobalBorderColor(restaurant.borderColor);
      this.formatStyleService.setGlobalPrimaryTextColor(restaurant.primaryTextColor);
      this.formatStyleService.setGlobalSecondaryTextColor(restaurant.secondaryTextColor);

      if (restaurant.availableStatus) {
        this.restaurantStore.setRestaurantAvailableStatus(restaurant.availableStatus);
        this.restaurantStore.setRestaurantIsAvailable(true);
      } else {
        this.restaurantStore.setRestaurantIsAvailable(false);
      }

      if (restaurant.isLoyaltyEnabled) {
        this.paymentStore.useLoyaltyChecked = true;
        this.cartStore.isLoyaltyEnabled = restaurant.isLoyaltyEnabled;
        this.cartStore.loyalty = new Loyalty(
          [],
          this.cartStore.loyalty ? this.cartStore.loyalty.pointsValue : 0,
          true
        );
      }

      if (restaurant.enablePromoCodes) {
        this.restaurantStore.checkRouteContainsDiscountOption();
      }
  
      this.isShowAgeGateModal = restaurant.showAgeGate;

      if (!restaurant.isAcceptingOrders || !restaurant.isMobileEnabled) {
        if (restaurant.merchantId !== 'MLY1D9AYCT14N') {
          this.isShowRestaurantClosedModal = true;
        }
        this.isRestaurantClosed = true;
      }

      if (this.restaurantStore.filteredWorkHours) {
        this.filteredWorkDays =
          this.formatDataService.formatIfStoreContinueWorking(this.restaurantStore.filteredWorkHours[restaurant.locationId]);
      }

      this.isTaxes = false;
      this.getRestaurantAvailableStatus();
      this.restaurantStore.checkIsCatalogUploaded(restaurant.merchantId)
        .subscribe((result: any) => {
          this.getRestaurantCatalogData(result.uploaded);
        });

      if (this.restaurantStore.isKioskSmsOrder) {
        this.router.navigate([`${this.merchantUrl()}/locations/${this.locationId}`, 'checkout']).then(() => {
          this.restaurantStore.isKioskSmsOrder = false;
        });
      }
    }
  }

  public async getFlavorRestaurant(): Promise<void> {
    let address = await this.storageService.get("address")
    this.orderWithFlavorStore.getRestaurantById(this.locationId, address)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(restaurant => {
        if(restaurant){
          this.titleService.setTitle(restaurant.name)
        }
      }
      );
  }

  public getRestaurant(): void {
    this.restaurantStore.getRestaurantById(this.locationId)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(restaurant => this.setupRestaurantDetails(restaurant));
  }

  private merchantUrl(): string {
    return `merchants/${this.merchantId}`;
  }

  private getRestaurantCatalogData(isCatalogUploaded: boolean): void {
    const merchantId = this.restaurantStore.isKioskSmsOrder ? this.merchantId : this.routeService.getMerchantId();
    this.restaurantStore.clearCurProducts();
    this.restaurantStore.getRestaurantCatalogData(this.locationId, isCatalogUploaded, this.isCategoriesCollapsable, merchantId).pipe(
      takeUntil(this.destroyed$),
      filter(Boolean),
      concatMap((response: CatalogData) => {
        this.filteredProductList = [];
        this.restaurantCategories = [];
        response.categories = organizeCategories(response.categories, this.restaurant);
        this.taxes = response.taxes.length === 1 && response.taxes[0].id === this.locationId ? [] : response.taxes;
        this.restaurantCategories = [...response.categories];
        if (this.restaurant.showNotCurrentlySoldCategory) {
          const newCategory = new RestaurantCategory('custom_sold_out', 'Not Currently Sold');
          this.restaurantCategories.push(newCategory);
        }
        this.activeCategoryId = this.restaurantCategories[0]?.id;

        return from(this.restaurantCategories).pipe(
          concatMap(category => this.loadCategoryAndSubcategories(this.locationId, merchantId, category, isCatalogUploaded))
        );
      })
    ).subscribe(
      {
      next: () => {
      },
      error: (err) => console.error('Error occurred:', err),
      complete: () => {
        if (this.restaurant.enableFavoriteItems) {
          const favoriteCategory = new RestaurantCategory('Favorites', 'Favorites');
          favoriteCategory.items = [];
          this.restaurantCategories.unshift(favoriteCategory);
        }
        this.createOrder();
        this.restaurantStore.loadItemsInProgress = false;
        if (this.isStoneCreek) {
          this.utilService.dismissActiveLoader();
        }
        this.updateFavoriteProducts();
      }
    }
  );
  }


  private loadCategoryAndSubcategories(locationId: string, merchantId: string, category: RestaurantCategory, isCatalogUploaded: boolean): Observable<void> {
    return this.loadNextCategory(locationId, merchantId, category, isCatalogUploaded).pipe(
      concatMap(() =>
        from(category.subCategories).pipe(
          concatMap(subCategory => this.loadCategoryAndSubcategories(locationId, merchantId, subCategory, isCatalogUploaded))
        )
      ),
      mapTo(void 0)
    );
  }


  private loadNextCategory(locationId: string, merchantId: string, category: RestaurantCategory, isCatalogUploaded: boolean): Observable<void> {
    if ((!this.isShowClosedModal || !this.isShowRestaurantClosedModal)
      && !this.isShowAgeGateModal
      && this.isStoneCreek
      && !this.utilService.isLoaderActive
      && this.platform.is(Platforms.CORDOVA)
    ) {
      this.utilService.activeLoader('Loading products...');
    }

    return this.restaurantStore.getProductsByCategoryId(locationId, isCatalogUploaded, false, category, merchantId)
      .pipe(
        tap((products: RestaurantProduct[]) => {
          this.setCategoryToRestaurant(products, category);
          this.isTaxes = true;
          const allVariationIds = this.restaurantStore.getCategoryVariationIds(products);
          this.filterProducts(products);
          const variationIdsWithInventory = this.restaurantStore.getUseInventoryItems(products);
          if (this.restaurant.enforceInventory && allVariationIds.length > 0) {
            this.loadNextVariationsInventory(locationId, allVariationIds);
          } else if (variationIdsWithInventory.length > 0) {
            this.loadNextVariationsInventory(locationId, variationIdsWithInventory);
          }
        }),
        mapTo(void 0)
      );
  }

  private createOrder(): void {
    if (!this.cartStore.orderMap[this.locationId] && !this.cartStore.updateCartInProgress && (this.restaurant.allowScheduledPickups || this.restaurant.isAcceptingOrders)) {
      this.cartStore.updateCartInProgress = true;
      const order = this.orderApiService.createOrder(this.locationId);
      this.sendOrder(this.locationId, order);
    }
  }

  private loadNextVariationsInventory(locationId: string, variationIdList: string[]) {
    for (let i = 0; i < variationIdList.length; i += 100) {
      this.restaurantStore.getProductsInventory(locationId, variationIdList.slice(i, i + 100)).subscribe();
    }
  }

  public checkCustomInstruction(): void {
    if (this.route.snapshot.queryParams.customInstruction) {
      sessionStorage.setItem(UrlParam.customInstruction, decodeURIComponent(this.route.snapshot.queryParams.customInstruction));
    }
  }

  public showProductModal(product: RestaurantProduct) {
    this.selectedProduct = product;
    if (!this.isMobile) {
      this.isShowProductModal = true;
    } else if (!this.restaurantStore.openItemCardInProgress) {
      this.restaurantStore.openItemCardInProgress = true;
      this.createModal();
    }
  }

  async createModal() {
    const modal = await this.modalController.create({
      component: ProductModalComponent,
      componentProps: {
        restaurant: this.restaurant,
        defaultProduct: this.selectedProduct,
        locationId: this.locationId,
        taxes: this.taxes,
        isClosed: this.isRestaurantClosed,
        isModal: false,
        allowScheduledPickups: this.restaurant.allowScheduledPickups,
        isMobileEnabled: this.restaurant.isMobileEnabled,
        enforceInventory: this.restaurant.enforceInventory,
        hoursOfOperation: this.restaurant.hoursOfOperation,
        currencySign: this.restaurantStore.restaurantCountryInfo.currencySign,
        isRestaurantHaveEnabledWorkDays: this.isRestaurantHaveEnabledWorkDays
      }
    });

    modal.onDidDismiss().then(data => {
      const item = data['data'] ? data['data'].cartProduct : null;
      this.restaurantStore.openItemCardInProgress = false;
      if (item != null) {
        this.onAddItemToCart(item);
      }
    });
    await modal.present();
  }

  public filterProducts(products: RestaurantProduct[]) {
    const newCategory: any = [];
    for (const item of products) {
      let showItem = true;
      if (this.restaurant
          && // Hide unorderable time-restricted items during service for ASAP orders
          (this.restaurant.isAcceptingOrders
          && !this.restaurant.allowScheduledPickups
          && !this.restaurant.showAllTimeRestrictedItems
          && !this.validateItemAvailableTimes(item))
          || // Hide items with incorrect fulfillment types
          (!this.restaurant.showAllFulfillmentRestrictedItems
          && !this.validateItemAvailableFulfillments(item))) {
        showItem = false;
      }
      if (showItem) {
        newCategory.push(item);
      }
    }
    if (newCategory.length > 0) {
      this.filteredProductList.push(newCategory);
    }
  }

  private getRestaurantAvailableStatus(): void {
    this.restaurantStore.restaurantAvailableStatus$
      .pipe(filter(Boolean), takeUntil(this.destroyed$))
      .subscribe((restaurantAvailableStatus: RestaurantAvailableStatus) => {
        const {isCurbsideEnabled, isTablesideEnabled, isPickupEnabled, isDeliveryEnabled, isXSideEnabled, isFridgeEnabled} = restaurantAvailableStatus;
        this.restaurantStore.getRestaurantFulfillment(this.restaurant, this.restaurantStore.fulfillmentParams);

        // If restricting fulfillment using query params, don't allow orders if matching fulfillment disabled
        if (this.restaurantStore.fulfillmentParams != null && this.restaurantStore.fulfillmentParams.length > 0 && this.restaurant.isMobileEnabled) {
          const fulfillmentStatus = {
            'pickup': isPickupEnabled,
            'curbside': isCurbsideEnabled,
            'tableside': isTablesideEnabled,
            'delivery': isDeliveryEnabled,
            'xside': isXSideEnabled,
            'fridge': isFridgeEnabled
          };
          const activeFulfillments = this.restaurantStore.fulfillmentParams.filter(param => fulfillmentStatus[param]);
          this.restaurant.isMobileEnabled = activeFulfillments.length > 0;
          if (!this.restaurant.isMobileEnabled) {
            this.isShowRestaurantClosedModal = true;
            this.isRestaurantClosed = true;
          }
        }
      });
  }

  private validateItemAvailableTimes(item: RestaurantProduct): boolean {
    const isValidLeadTime = this.validateItemLeadTime(item);
    const isValidWeekDay = this.validateItemAvailableDays(item);

    return isValidLeadTime && isValidWeekDay;
  }

  private validateItemLeadTime(item: RestaurantProduct): boolean {
    const productValidVariations: boolean[] = [];
    for (const variation of item?.variations) {
      if (variation.isLeadTimesEnabled) {
        productValidVariations.push(this.itemValidateService.validLeadTime(variation, this.restaurant.hoursOfOperation));
      } else {
        productValidVariations.push(true);
      }
    }

    return productValidVariations.filter(variation => variation === true).length > 0;
  }

  private validateItemAvailableDays(item: RestaurantProduct): boolean {
    const productValidVariations: boolean[] = [];
    for (const variation of item?.variations) {
      if (variation.isDailyRestrictionEnabled) {
        productValidVariations.push(this.itemValidateService.validDayRestriction(variation));
      } else {
        productValidVariations.push(true);
      }
    }

    return productValidVariations.filter(variation => variation === true).length > 0;
  }

  private validateItemAvailableFulfillments(item: RestaurantProduct): boolean {
    const productValidVariations: boolean[] = [];
    item.variations.forEach(variation => {
      if (variation.isFulfillmentRestrictionEnabled) {
        productValidVariations.push(this.itemValidateService.validFulfillments(variation, this.restaurantStore.enabledFulfillments));
      } else {
        productValidVariations.push(this.checkCategory(variation, item.categoryId));
      }
    });
    return productValidVariations.filter(variation => variation === true).length > 0;
  }

  private checkCategory(variation: ProductVariation, categoryId: string): boolean {
    let isAvailable = true;
    this.restaurantStore.curCategories.map(category => {
      if (category.id === categoryId && category.isFulfillmentRestrictionEnabled) {
        variation.availableInFulfillments = category.availableInFulfillments;
        isAvailable = this.itemValidateService.validFulfillments(variation, this.restaurantStore.enabledFulfillments);
      }
    });
    return isAvailable;
  }

  public isProductSold(product: RestaurantProduct): boolean {
    const variationsAvailable = [];
    for (const variation of product.variations) {
      if (variation.trackInventory && (this.restaurant?.enforceInventory || variation.useInventory)) {
        if (variation.quantityRemaining > 0) {
          variationsAvailable.push(variation);
        }
      } else {
        return false;
      }
    }
    return variationsAvailable.length === 0;
  }

  public changeCategoryCollapseState(category: RestaurantCategory): void {
    if (this.isCategoriesCollapsable) {
      category.isCollapse = !category.isCollapse;
      category.hideItems = !category.hideItems;
    }
  }

  public isCategoryProductHidden(product: RestaurantProduct, categories: RestaurantCategory[], i: number): boolean {
    if (!categories || !categories.length) {
      return false;
    }
    return categories[i].hideItems;
  }

  public productCollapseState(product: RestaurantProduct, categories: RestaurantCategory[], i: number): ProductCollapseState {
    if (!categories || !categories.length) {
      return ProductCollapseState.SHOW;
    }
    return this.isCategoryProductHidden(product, categories, i) ? ProductCollapseState.HIDE : ProductCollapseState.SHOW;
  }

  public goToCheckout() {
    const locationUrl = this.routeService.getLocationUrl();
    (this.itemService.checkMerchantId() || this.itemService.checkLocationId(this.locationId)) && !this.itemService.checkServiceItem() ?
      this.router.navigate([locationUrl, 'checkout', URL.service_items]).catch(error => console.error(error)) :
      this.router.navigate([locationUrl, 'checkout']).catch(error => console.error(error));
  }

  public closeProductModal(): void {
    this.isShowProductModal = false;
    this.selectedProduct = null;
  }

  public closeTabModal(): void {
    this.cartStore.showTabModal = false;
  }

  public closeAgeGateModal(): void {
    this.isShowAgeGateModal = false;
  }

  private isItemEligibleForSubscription(itemId: string, subscriptionsData: any[]): boolean {
    if (!subscriptionsData?.length) {
      return false;
    }
  
    return subscriptionsData.some(subscription => 
      subscription.eligibleItemIds?.includes(itemId)
    );
  }
  

  public onAddItemToCart(item: MenuItemForPayment): void {
    if (!this.cartStore.updateCartInProgress) {
      if (item == null) {
        return;
      }
      this.cartStore.addItemToCart(item);
      this.cartStore.updateCartInProgress = true;
      const order = this.orderApiService.createOrder(item.locationId);
      if (!this.cartStore.orderMap[item.locationId]) {
        this.sendOrder(item.locationId, order);
      } else {
        this.calculateOrder(item.locationId, order);
      }
      if (this.addItemQueue.length === 0) {
        this.closeProductModal();
      }
    } else {
      this.addItemQueue.push(item);
      this.closeProductModal();
    }
  }

  public isHideCategory(category: RestaurantCategory): boolean {
    if (!category.items.length) {
      return true;
    }
    if (category.subCategories.length) {
      return category.subCategories.every(subCategory =>
        !subCategory.items.some(item => this.isShowDailyAvailabilityItem(item, this.restaurant))
      ) && !category.items.some(item => this.isShowDailyAvailabilityItem(item, this.restaurant));
    }
    if (category.subCategories.length && !category.items.length) {
      return category.subCategories.every(subCategories => !subCategories.items.length) && !category.items.length;
    }
    return !category.items.some(item => this.isShowDailyAvailabilityItem(item, this.restaurant));
  }

  public isHideSubCategory(category: RestaurantCategory): boolean {
    return !category.items.length || !category.items.every(item => this.isShowDailyAvailabilityItem(item, this.restaurant));
  }

  private sendOrder(locationId: string, order: Order): void {
    order.applied_taxes = this.taxes.map(tax => tax.id);
    this.orderApiService.sendOrder(locationId, order)
      .subscribe(({id, total_money, discounts, taxes}: any) => {
        const amount = total_money.amount - this.cartStore.taxesSum(taxes);
        this.cartStore.orderMap[locationId] = {id, order, amount, discounts, taxes, loyaltyPoints: 0, isUpdated: false, isSubmitted: false, isPaid: false};
        this.paymentStore.isWaitingUpdate = false;
        this.cartStore.updateCartInProgress = false;
        this.addNextItem();
      });
  }

  private calculateOrder(locationId: string, order: Order): void {
    const orderMap = this.cartStore.orderMap[locationId];
    if (this.cartStore.tab) {
      order.is_additional_tab_round = true;
      order.fulfillment_type = FulfillmentType.TABLESIDE;
      order.is_tab_order = true;
    }
    this.orderApiService.calculateOrder(locationId, order)
      .subscribe(({total_money, taxes, discounts, accumulated_loyalty_points, line_items, estimated_duration}: any) => {
        const totalPrice = total_money.amount - this.cartStore.taxesSum(taxes);
        this.cartStore.updateOrderMapData(locationId, order, totalPrice, taxes, discounts, accumulated_loyalty_points, line_items, estimated_duration);
        this.paymentStore.isWaitingUpdate = false;
        this.cartStore.updateCartInProgress = false;
        this.addNextItem();
      }, () => this.addNextItem());
  }

  private addNextItem() {
    this.cartStore.updateCartInProgress = false;
    if (this.addItemQueue.length !== 0) {
      this.onAddItemToCart(this.addItemQueue[0]);
      this.addItemQueue.shift();
    }
  }

  private scrollToCategoryTab(categoryIndex: number): void {
    if (this.categoryTabArray[categoryIndex]) {
      this.categoryTabArray[categoryIndex].nativeElement.scrollIntoView({inline: 'center'});
    }
  }

  private getSubscriptionData(): void {
    this.orderApiService.getSubscriptionData(this.locationId, this.restaurantStore.subscriptionCode)
      .pipe(takeUntil(this.destroyed$))
      .subscribe((subscriptionData: SubscriptionPhase[]) => {
        if (subscriptionData != null && subscriptionData.length > 0) {
          this.cartStore.subscriptionsData = subscriptionData;
        } else {
          this.restaurantStore.subscriptionCode = null;
        }
      }, (error) => {
        if (error.error.message.includes('not found')) {
          this.restaurantStore.subscriptionCode = null;
        }
      });
  }

  public closeRestaurantClosedModal(): void {
    this.isShowRestaurantClosedModal = false;
    this.isModalWasClosed = true;
  }

  private checkOrdersIsEmptyField(): void {
    this.ordersIsEmpty = (this.ordersIsEmpty === undefined) ? true : this.ordersIsEmpty;
  }

  public getIsCatalogEmpty(): void {
    this.restaurantStore.catalogIsEmpty$.subscribe(isEmpty => {
      this.isCatalogEmpty = isEmpty;
    });
  }

  public clearCache(locationId = null): void {
    this.destroyed$.next();
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    const merchantId = this.routeService.getMerchantId();
    this.router.navigate([BASE_URL_PATH, merchantId, 'locations', locationId]);
  }
  private async checkSharedOrder(): Promise<void> {
    if (this.restaurant.enableSharedOrders &&
      !this.sharedOrderService.sharedOrderId$ &&
      !this.sharedOrderService.sharedOwnerId$
    ) {
      const dialogRef = this.dialog.open(SharedOrdersModalComponent, {
        data: {
          restaurant: this.restaurant,
          isView: false
        },
        height: 'fit-content',
        width: '600px',
      });
      dialogRef.afterClosed().subscribe(result => {
        const sharedOrder = sessionStorage.getItem(UrlParam.sharedOwnerId);
        if (sharedOrder) {
          const queryParams = { ...this.router.getCurrentNavigation()?.finalUrl.queryParams };
          queryParams[UrlParam.sharedOwnerId] = sharedOrder;
          this.router.navigate([], {
            queryParams,
            queryParamsHandling: 'merge'
          });
        }
      });
    }
  }

  private getSavedItems(): void {
    if (this.sharedOrderService.sharedOwnerId$ && !this.cartStore.items.length) {
      this.sharedOrderService.getStorageItems();
      this.sharedOrderService.getStorageSharedOrder();
    }
  }

  public isFavorite(product: RestaurantProduct): boolean {
    return this.favoriteProductService.isFavorite(product, this.favoriteItems);
  }

  private findFavoriteItems(categories: RestaurantCategory[], favoriteItems: string[]) {
    const foundFavorites = new Set<any>();
    function search(categoryList: RestaurantCategory[]) {
      for (const category of categoryList) {
        for (const item of category.items) {
          if (favoriteItems.includes(item.info.id)) {
            foundFavorites.add(item);
          }
        }
        if (category.subCategories && category.subCategories.length > 0) {
          search(category.subCategories);
        }
      }
    }
    search(categories);
    return foundFavorites;
  }

  private updateFavoriteProducts() {
    if (this.restaurantCategories.length && this.restaurantCategories[0].id === 'Favorites') {
      const items = Array.from(this.findFavoriteItems(this.restaurantCategories, this.favoriteItems));
      this.restaurantCategories[0].items = items;
      this.restaurantCategories[0].hideItems = !items.length;
    }
  }

  private async setupCustomerFavoriteItems () {
    const customer = await this.storageService.get(STORAGE_CUSTOMER_DATA);
    if (customer && customer.orderBotUserId) {
      this.orderBotUserId = customer.orderBotUserId;
      this.customerStore.loadFavoriteItems(this.orderBotUserId);
    }
    this.customerStore.favoriteItems$.subscribe((items) => {
      this.favoriteItems = items;
      this.updateFavoriteProducts();
    });
  }

  private setCategoryToRestaurant(products: RestaurantProduct[], category: RestaurantCategory): void {
    if (this.restaurant.showSoldOutItems_last) {
      products.sort((a, b) => {
        const aSold = this.itemService.isSoldOut(a, this.restaurant) ? 1 : 0;
        const bSold = this.itemService.isSoldOut(b, this.restaurant) ? 1 : 0;
        return aSold - bSold;
      });
    }
    if (this.restaurant.showNotCurrentlySoldCategory) {
      const customCategory = this.restaurantCategories.find(cat => cat.id === 'custom_sold_out');
      if (customCategory) {
        const available: RestaurantProduct[] = [];
        for (const product of products) {
          if (!isItemDailyAvailable(product)) {
            customCategory.items.push(product);
          } else {
            available.push(product);
          }
        }
        products.length = 0;
        products.push(...available);
      }
    }
    const setProductsInCategory = (categories: RestaurantCategory[], categoryId: string, productsSet: RestaurantProduct[]) => {
      for (const cat of categories) {
        if (cat.id === categoryId) {
          cat.items = productsSet;
          return true;
        }
        if (cat.subCategories?.length) {
          const found = setProductsInCategory(cat.subCategories, categoryId, productsSet);
          if (found) return true;
        }
      }
      return false;
    };
    setProductsInCategory(this.restaurantCategories, category.id, products);
  }
}
